// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const carvanha: PokeData = {
  "id": 318,
  "name": "carvanha",
  "height": 8,
  "weight": 208,
  "base_experience": 61,
  "types": [
    PokeType.WATER,
    PokeType.DARK
  ],
  "api_moves": [
    "take-down",
    "leer",
    "bite",
    "agility",
    "rage",
    "screech",
    "focus-energy",
    "scary-face",
    "swagger",
    "crunch",
    "poison-fang",
    "assurance",
    "ice-fang",
    "aqua-jet",
    "liquidation"
  ],
  "moves": [
    "leer",
    "bite",
    "agility",
    "scary-face",
    "crunch",
    "poison-fang",
    "ice-fang",
    "aqua-jet",
    "liquidation",
    "hydro-pump",
    "whirlpool",
    "rain-dance",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 160,
    "item": null,
    "species": [
      {
        "name": "carvanha",
        "order": 346,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sharpedo",
        "order": 347,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": 318,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 32.5,
    "speed": 65,
    "ability_power": 90
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
